<template>
  <div id="ebHansontable">
    <HotTable class="eb-handsontable" ref="testRoot" root="testRoot" :settings="addRemoveIcon"></HotTable>
  </div>
</template>
<script>
import HotTable from '@handsontable/vue';
import eventBus from '@/plugins/event-bus';
import $ from 'jquery';
export default {
  name: 'ebHansontableEdit',
  props: {
    hotSettings: {
      required: true
    },
    addRowName: {
      type: String
    },
    isAfterRenderer: {
      default: false
    }
  },
  data: function() {
    return {};
  },
  components: {
    HotTable
  },
  mounted() {
    this.addRow();
    this.removeRow();
    if (this.isAfterRenderer) {
      this.onAfterChange();
    }
  },
  computed: {
    addRemoveIcon: function() {
      let that = this;
      this.hotSettings.columns.map(function(ele, index, self) {
        if (ele && ele.data && ele.data === 'removeRow') {
          that.hotSettings.data.map(function(ele1, index1, self1) {
            if (ele1) {
              ele1['removeRow'] = '<i class="icon iconfont icon-shanchu eb-shanchu"></i>';
            }
          });
        }
      });
      return this.hotSettings;
    }
  },
  methods: {
    addRow: function() {
      eventBus.$on(this.addRowName, () => {
        if (this.$refs['testRoot']) {
          let hotTable = this.$refs['testRoot'].table;
          let colHeaderArr = hotTable.getColHeader();
          hotTable.alter('insert_row');
          if (colHeaderArr[colHeaderArr.length - 1] === '删除') {
            this.hotSettings.data[this.hotSettings.data.length - 1]['removeRow'] =
              '<i class="icon iconfont icon-shanchu eb-shanchu"></i>';
          }
          this.resetPanelHeight();
        }
      });
    },
    removeRow: function() {
      let hotTable = this.$refs['testRoot'].table;
      $('#ebHansontable').on('click', '.eb-shanchu', () => {
        let row = hotTable.getActiveEditor().row;
        this.$emit('removeRowEvent', {
          row: row,
          next: row => {
            hotTable.alter('remove_row', row);
            this.resetPanelHeight();
          }
        });
      });
    },
    resetPanelHeight: function() {
      var lineHeight = $('#ebHansontable').height() + 50;
      $('#ebHansontable')
        .parents('.ebPanel')
        .height(lineHeight);
      $('#ebHansontable')
        .parents('.ebPanel')
        .find('.panel-red-line')
        .height(lineHeight);
    },
    onAfterChange: function() {
      let hotTable = this.$refs['testRoot'].table;
      hotTable.addHook('afterChange', () => {
        this.resetPanelHeight();
      });
      hotTable.addHookOnce('afterChange', () => {
        var lineHeight = $('#ebHansontable').height() + 50;
        $('#ebHansontable')
          .parents('.ebPanel')
          .height(lineHeight);
        $('#ebHansontable')
          .parents('.ebPanel')
          .find('.panel-red-line')
          .height(15);
      });
    }
  },
  beforeDestroy() {
    eventBus.$off(this.addRowName);
  }
};
</script>
<style scoped lang="less">
</style>
